import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import { cookieOptions } from 'remote-com-shared/components/CookieScripts/variables';

const allTrackingParameters = ['irclickid', 'utm_source', 'utm_campaign', 'utm_content'];
const monthsOfExpiration = 3; // Around 90 days
const expirationDate = (monthsOfExpiration / 12) * 365;

export function useTrackingParameters() {
  const firstTime = useRef(true);
  const { isReady, query } = useRouter();

  useEffect(() => {
    if (isReady && firstTime.current) {
      firstTime.current = false;

      const someParametersExist = allTrackingParameters.some(
        (parameterKey) => !!query[parameterKey]
      );

      // Early exit if not all parameters exist
      if (!someParametersExist) {
        return;
      }

      allTrackingParameters.forEach((id) => {
        if (query[id]) {
          Cookies.set(`remote_${id}`, query[id], {
            ...cookieOptions,
            expires: expirationDate,
          });
        }
      });
    }
  });
}

export function useImpactFormValues() {
  const router = useRouter();

  if (typeof window === 'undefined') {
    return {};
  }

  return {
    impact_clickid:
      (router.isReady && router.query.irclickid) || Cookies.get('remote_irclickid') || '',
    impact_irmpname:
      (router.isReady && router.query.utm_campaign) || Cookies.get('remote_utm_campaign') || '',
    impact_irpid:
      (router.isReady && router.query.utm_content) || Cookies.get('remote_utm_content') || '',
  };
}
